import { createActions } from 'redux-actions'

export const INIT_REPORT_INFO = "INIT_REPORT_INFO";

export const REQUEST_REPORT_START = "REQUEST_REPORT_START";
export const REQUEST_REPORT_SUCCESS = "REQUEST_REPORT_SUCCESS";
export const REQUEST_REPORT_FAIL = "REQUEST_REPORT_FAIL";

export const CREATE_REPORT_START = "CREATE_REPORT_START";
export const CREATE_REPORT_SUCCESS = "CREATE_REPORT_SUCCESS";
export const CREATE_REPORT_FAIL = "CREATE_REPORT_FAIL";

export const {

  initReportInfo,
  requestReportStart,
  requestReportSuccess,
  requestReportFail,

  createReportStart,
  createReportSuccess,
  createReportFail,

} = createActions({

  [INIT_REPORT_INFO]: (req) => ({ req }),

  [REQUEST_REPORT_START]: (req) => ({ ...req }),
  [REQUEST_REPORT_SUCCESS]: (res) => ({ res }),
  [REQUEST_REPORT_FAIL]: (res) => ({ res }),

  [CREATE_REPORT_START]: (req) => ({ ...req }),
  [CREATE_REPORT_SUCCESS]: (res) => ({ res }),
  [CREATE_REPORT_FAIL]: (res) => ({ res }),

})


